module.exports = __webpack_public_path__ + "img/download tips@2x.9d59c0e8.png";